import { lostDeals, LostDeal, totalLostRevenue } from "@/mocks/rop";

function formatMoney(value: number): string {
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(value);
}

interface LostDealsModalProps {
  onClose: () => void;
}

export default function LostDealsModal({ onClose }: LostDealsModalProps) {
  const reasonCounts: Record<string, number> = {};
  lostDeals.forEach((d: LostDeal) => {
    const reason = d.reason.split(" (")[0];
    reasonCounts[reason] = (reasonCounts[reason] || 0) + 1;
  });

  return (
    <div className="fixed inset-0 bg-foreground-950/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg border border-[#D5CA8A] w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 bg-[#FEF3C7] border-b border-[#D5CA8A] rounded-t-lg">
          <div className="flex items-center gap-2">
            <i className="ri-close-circle-line text-[#DC2626]"></i>
            <span className="text-[12px] font-semibold text-[#2D2D2D]">Потерянные сделки ({lostDeals.length})</span>
            <span className="text-[10px] text-[#DC2626] ml-2">Упущено: {formatMoney(totalLostRevenue)}</span>
          </div>
          <button onClick={onClose} className="w-6 h-6 flex items-center justify-center rounded hover:bg-[#E8DB6C] cursor-pointer">
            <i className="ri-close-line text-[#666666]"></i>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {/* Reasons Summary */}
          <div className="grid grid-cols-2 gap-2 mb-4">
            {Object.entries(reasonCounts).map(([reason, count]) => (
              <div key={reason} className="p-2 bg-[#FEE2E2] rounded-lg">
                <p className="text-[14px] font-bold text-[#DC2626]">{count}</p>
                <p className="text-[10px] text-[#DC2626]">{reason}</p>
              </div>
            ))}
          </div>

          <div className="space-y-2">
            <div className="flex items-center text-[10px] text-[#666666] px-2 py-1 bg-[#FDF2B5] rounded">
              <span className="flex-1">Клиент</span>
              <span className="w-[80px] text-right">Сумма</span>
              <span className="w-[100px] text-right">Этап</span>
              <span className="w-[90px] text-right">Менеджер</span>
              <span className="w-[80px] text-right">Дата</span>
            </div>
            {lostDeals.map((d: LostDeal) => (
              <div key={d.id} className="flex items-center text-[10px] px-2 py-2 border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/20 rounded transition-colors">
                <span className="flex-1 text-[#2D2D2D] truncate">{d.client.replace("ООО ", "").replace("АО ", "")}</span>
                <span className="w-[80px] text-right text-[#DC2626] font-medium">{formatMoney(d.amount)}</span>
                <span className="w-[100px] text-right text-[#666666] truncate">{d.stage}</span>
                <span className="w-[90px] text-right text-[#666666]">{d.manager}</span>
                <span className="w-[80px] text-right text-[#666666]">{d.lostDate}</span>
              </div>
            ))}
          </div>

          <div className="mt-4 p-3 bg-[#FEF3C7] rounded-lg">
            <p className="text-[11px] font-semibold text-[#2D2D2D] mb-1">Анализ причин отказов</p>
            <p className="text-[10px] text-[#666666]">
              Основная причина потерь — уход к конкурентам (3 сделки, {formatMoney(lostDeals.filter(d => d.reason.includes("конкурентам")).reduce((s, d) => s + d.amount, 0))}).
              Второй по значимости фактор — ценовая политика: 2 сделки потеряны из-за цены выше рынка.
              Рекомендация: пересмотреть ценообразование на костюмные и мебельные ткани, подготовить конкурентные КП с акцентом на качество и сроки поставки.
            </p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 px-4 py-3 border-t border-[#D5CA8A] bg-[#FFF9E6] rounded-b-lg">
          <button onClick={onClose} className="px-3 py-1.5 rounded text-[11px] text-[#666666] hover:bg-[#FDF2B5] cursor-pointer transition-colors whitespace-nowrap">
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}